<!--周转补货单列表-->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container order-query">
      <el-form size="small" :inline="true" :model="listQuery">
        <!--     单据编号   -->
        <el-form-item size="mini" :label="$t('poOrderAgent.provideno')">
          <el-input v-model.trim="listQuery.provideno" clearable :placeholder="$t('')"/>
        </el-form-item>
        <!--          搜索-->
        <el-button size="mini" type="primary" icon="el-icon-search" @click="handleFilter">{{
            $t('function.menu.search')
          }}
        </el-button>
        <!--          导出  -->
        <el-button size="mini" v-if="this.isAgent"  type="success" icon="el-icon-document" :loading="btnloading" @click="handleExport">{{ $t('corp.common.export') }}</el-button>
      </el-form>
      <el-table
          :key="tableKey"
          v-loading="listLoading"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          style="width: 100%;"
      >
        <!-- 操作 -->
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="100" align="center">
          <template v-slot="{row}">
            <!-- 查看 -->
            <el-button circle type="primary" size="mini" icon="el-icon-search" :title="$t('button.view')" @click="handleView(row)"/>
            <!-- 支付 -->
            <el-button v-show="row.status === 0" circle size="mini" type="success" icon="el-icon-goods" :title="$t('Common.pay')" @click="handleUpdate(row)"/>
            <!-- 收货 -->
            <el-button
                v-if="row.status === 1 && row.sendStatus === 1 && row.recStatus === 0"
                circle
                size="mini"
                type="success"
                icon="el-icon-folder-checked"
                :title="$t('lm.goods.receipt')"
                @click="handleReceiving(row)"
            />
          </template>
        </el-table-column>
        <!--      代办处编号-->
        <el-table-column :label="$t('miAgent.agentNo')" prop="agentNo" align="center"/>
        <!--      公司编号-->
        <el-table-column :label="$t('pmProductSppm.company')" prop="companycode" align="center"/>
        <!--      单据编号-->
        <el-table-column :label="$t('poOrderAgent.provideno')" prop="provideno" align="center"/>
        <!--      单据类型-->
        <el-table-column :label="$t('fiAcInput.orderType')" align="center">
          <template v-slot="{row}">
            {{ $lt(initDict.orderType, row.providetype) }}
          </template>
        </el-table-column>
        <!--      创建人-->
        <el-table-column :label="$t('pmProductSppm.createUser')" prop="creatorCode" align="center"/>
        <!--      创建时间-->
        <el-table-column :label="$t('Common.createTime')" prop="createTime" align="center"/>
        <!--      单据状态-->
        <el-table-column :label="$t('pdRetManifest.receiptStatus')" align="center">
          <template v-slot="{row}">
            {{ $lt(initDict.status, row.status) }}
          </template>
        </el-table-column>
        <!--      审核人-->
        <el-table-column :label="$t('poLpOrder.checkUser')" prop="checkCode" align="center"/>
        <!--      审核时间-->
        <el-table-column :label="$t('pmProductSppm.checkDate')" prop="checkTime" align="center"/>
        <!--      备注-->
        <el-table-column :label="$t('poReturn.createRemark')" prop="remark" align="center"/>
        <!--      收货人地址-->
        <el-table-column :label="$t('pdSendInfo.recipientAddr')" prop="recAddr" align="center"/>
        <!--      收货人姓名-->
        <el-table-column :label="$t('PoOrder.recName')" prop="recName" align="center"/>
        <!--      联系电话-->
        <el-table-column :label="$t('sysCompany.phone')" prop="recPhone" align="center"/>
        <!--      发货人-->
        <el-table-column :label="$t('pd.sender')" prop="sendCode" align="center"/>
        <!--      发货时间-->
        <el-table-column :label="$t('order.shippment.sidate')" prop="sendTime" align="center"/>
        <!--      发货状态-->
        <el-table-column :label="$t('ai.sendinfo')" align="center">
          <template v-slot="{row}">
            {{ $lt(initDict.sendStatus, row.sendStatus) }}
          </template>
        </el-table-column>
        <!--      收货状态-->
        <el-table-column :label="$t('pd.recStatus')" align="center">
          <template v-slot="{row}">
            {{ $lt(initDict.recStatus, row.recStatus) }}
          </template>
        </el-table-column>
        <!--      取消人编号-->
        <el-table-column :label="$t('bdAdjustPv.cancelCode')" prop="cancelCode" align="center"/>
        <!--      取消时间-->
        <el-table-column :label="$t('common.cancelTime')" prop="cancelTime" align="center"/>
      </el-table>
      <!-- 分页组件 -->
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
      <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
      >
        <el-form size="small" :inline="true" :model="listQuery2">
          <!--     支付密码   -->
          <el-form-item size="mini" :label="$t('Common.pay.password')">
            <el-input type="password" v-model.trim="listQuery2.payPassword" clearable :placeholder="$t('')"/>
          </el-form-item>
          <el-button type="primary" size="mini" @click="btnPay">{{ $t('button.confirm') }}</el-button>
        </el-form>
        <span slot="footer" class="dialog-footer">
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// poOrderAgentPay
import {poOrderAgents, poOrderAgentPay, poOrderAgentRec, poOrderAgentsExcel} from "@/api/agent";
import {mapGetters} from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "TurnoverOrderList",
  components: { Pagination },
  data() {
    return {
      dialogVisible: false,
      sjopen: false,
      tableLoading: false,
      listLoading: false,
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        companyCode: null
      },
      listQuery2: {
        payPassword: ''
      },
      tableKey: 0,
      list: [],
      total: 0,
      canUseF$: 0,
      totalAmount: 0,
      wWeekList: null,
      companyCodelist: null,
      dcNoBuledialong: true,
      activeName: 'first',
      initDict: {
        orderType: 'po.order.agentstatus',
        status: 'po.agengtorder.astatus',
        sendStatus: 'sysaftersale.sendflag',
        recStatus: 'pd.recstatus'
      }
    }
  },
  mounted() {
    this.wWeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
    this.getList()
  },
  computed:{
    ...mapGetters([
      'isAgent'
    ]),
  },
  methods: {
    //  搜索
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.listLoading = true
      poOrderAgents({...this.listQuery}).then(res => {
        this.list = res.data.records
        this.listLoading = false
      }).catch(err => {
        console.error(err)
      })
    },
    handleView(row) {
      this.$router.push({name: 'TurnoverOrderView', params: {id: row.id}})
    },
    handleUpdate(row) {
      this.dialogVisible = true
      this.listQuery2 = {}
      this.listQuery2.id = row.id
    },
    btnPay() {
      if (this.listQuery2.payPassword == '') {
        this.$message.error(this.$t('please.input.your.pay.password'));
      }
      this.btnloading = true
      poOrderAgentPay({...this.listQuery2}).then(() => {
        this.btnloading = false
        this.getList()
        this.dialogVisible = false
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
      }).catch(err => {
        this.btnloading = false
        this.dialogVisible = false
        console.error(err)
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
      })
    },
    handleReceiving(row) {
      this.btnloading = true
      poOrderAgentRec({'id': row.id}).then(() => {
        this.btnloading = false
        this.getList()
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
      }).catch(err => {
        this.btnloading = false
        this.dialogVisible = false
        console.error(err)
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
      })
    },
    // 导出
    handleExport() {
      this.btnloading = true
      poOrderAgentsExcel({ ...this.listQuery }).then(response => {
        const lists = response.data
        for (let i = 0; i < lists.length; i++) {
          lists[i].sendStatus = this.$lt(this.initDict.sendStatus,lists[i].sendStatus)
        }
        const tHeader = [
          //   订单编号,商品编号,创建时间, 补货数量，是否发货，备注
          this.$t('poOrder.orderNo'),this.$t('pmProductList.productId'),this.$t('Common.createTime'),
          this.$t('stStockWarehouseAgentList.title'),this.$t('ai.sendinfo'),this.$t('poReturn.createRemark')
        ]	// 表头
        const filterVal = [
          'provideno','goodscode','createTime','quantity','sendStatus','remark'
        ]	 // 对应json数据中的key，顺序与表头顺序一致
        // 远程请求要导出的数据
        const data = this.formatJson(filterVal, lists)
        import('@/vendor/Export2Excel').then(excel => {
          excel.export_json_to_excel({
            header: tHeader,	// 表头，必填
            data,	// 具体数据，必填
            filename: 'excel',	// 导出文件名称，非必填
            autoWidth: true,	// 非必填
            bookType: 'xlsx'	// 非必填
          })
          this.btnloading = false
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>

<style scoped>

</style>
